import { useConfigContext } from '#src/contexts/config/index.ts';

import { useMonetaryAmount } from './useMonetaryAmount.ts';

export const useReferralProgramConfig = () => {
  const { referralProgramConfig } = useConfigContext();

  const { toMonetaryAmount, getUserFiatAmountInMajorUnit } =
    useMonetaryAmount();

  return {
    referralProgramConfig,
    userFiatAmount: referralProgramConfig
      ? getUserFiatAmountInMajorUnit(
          toMonetaryAmount(referralProgramConfig.maxDiscount)
        )
      : undefined,
  };
};
